import React, { Component } from "react";

function HeadingField(props) {
  var id = props.id,
      classNames = props.classNames,
      label = props.label,
      help = props.help,
      required = props.required,
      description = props.description,
      errors = props.errors,
      children = props.children,
      schema = props.schema;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      paddingTop: 15
    }
  }, schema.title));
}

export default HeadingField;